export const OUTBOUND = "Outbound";
export const RETURN = "Return";
